import { useState } from "react";

import { Box, Stack, IconButton, Alert, AlertTitle } from "@mui/material";

import { CombiChart } from "src/components/charts";
import { ChartIcon, TableIcon } from "src/components/icons";
import {
  TimeGranularityPicker,
  FormDialog,
  LoadingCircle,
  SavedFundsList,
  FormTypeDialog,
  ContentWrapper,
  FilterButton,
} from "src/components";
import TablePage from "./TablePage";
import { GranularityPicker } from "src/components/buttons/TimeGranularityPicker/GranularityPicker";

const AlertComponent = ({ title, description }: any) => {
  return (
    <Alert severity="error">
      <AlertTitle>{title}</AlertTitle>
      {description}
    </Alert>
  );
};

const MainPage = ({
  forecastData,
  timeRange,
  setTimeRange,
  isFetching,
}: any) => {
  const [open, setOpen] = useState(false);

  const [currentDataset, setCurrentDataset] = useState<
    ("portfolioData" | "serviceData" | "productsData")[]
  >(["portfolioData"]);
  const [page, setPage] = useState(0);

  return (
    <Box
      sx={{
        my: 10,
        display: "flex",
        justifyContent: open ? "end" : "center",
      }}
    >
      <FormDialog open={open} setOpen={setOpen} />

      <Box
        sx={{
          maxWidth: open ? "98vw" : "90vw",
          width: open ? "1800px" : "1200px",
          paddingRight: open ? "620px" : 0,
        }}
      >
        <Stack direction={"row"} justifyContent={"space-between"}>
          <Box />
          <FormTypeDialog openForm={setOpen} />{" "}
        </Stack>
        <SavedFundsList setOpen={setOpen} />
        <Stack direction={"row"} justifyContent={"end"} gap={"12px"}>
          <ContentWrapper value={page} index={1}>
            <IconButton onClick={() => setPage(0)}>
              <ChartIcon />
            </IconButton>
          </ContentWrapper>
        </Stack>
        <ContentWrapper value={page} index={0}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            sx={{ marginBottom: "24px" }}
          >
            <FilterButton
              currentDataset={currentDataset}
              setCurrentDataset={setCurrentDataset}
            />
            <Stack direction={"row"} gap={"12px"} justifyContent={"end"}>
              <GranularityPicker
                timeRange={timeRange}
                setTimeRange={setTimeRange}
              />
              <TimeGranularityPicker
                timeRange={timeRange}
                setTimeRange={setTimeRange}
                modelatedData={forecastData.raw}
              />
              <IconButton onClick={() => setPage(1)}>
                <TableIcon />
              </IconButton>
            </Stack>
          </Stack>
        </ContentWrapper>

        <>
          {isFetching && <LoadingCircle />}
          {forecastData.error ? (
            <AlertComponent
              title={forecastData.error.split("details:")[0]}
              description={forecastData.error.split("details:")[1]}
            />
          ) : forecastData.data ? (
            <>
              <ContentWrapper value={page} index={0}>
                <CombiChart
                  data={forecastData.data}
                  tableData={forecastData.raw}
                  loading={isFetching}
                  open={open}
                  currentDataset={currentDataset}
                />
              </ContentWrapper>
              <ContentWrapper value={page} index={1}>
                <TablePage data={forecastData.raw} setOpen={setOpen} />
              </ContentWrapper>
            </>
          ) : (
            <Box>
              Začněte modelovat portfolia přidáním instrumentů vpravo nahoře.
            </Box>
          )}
        </>
      </Box>
    </Box>
  );
};

export default MainPage;
